import List from './list'
import Edit from './edit'
import New from './new'
export default { List, Edit, New }
